module.exports = __webpack_public_path__ + "img/mayBanner_900.b1d45391.png";